<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', true)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- organizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- amount -->
        <td>
          <td-value
            copyToClipboard
            type="number"
            [value]="item?.amount"
          ></td-value>
        </td>

        <!-- isSend -->
        <td>
          <td-value type="boolean" [value]="item?.isSend"></td-value>
        </td>

        <!-- scheduledMessageId -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.scheduledMessageId"
          ></td-value>
        </td>

        <!-- lastSendDateTime -->
        <td>
          <td-value type="dateTime" [value]="item?.lastSendDateTime"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete($event.id, $event.organizationName)"
            (onUpdate)="onUpdate($event.id, false)"
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-credit-notification-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-credit-notification-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit [service]="currentService" [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()">
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
